


















































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import {
  isRoot,
  getCurrentUserId,
  getCurrentCompanyId,
  currentUserIsCompanyOwner
} from "@/plugins/roles";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import video, { VideoListParams } from "@/getinfo-api/video";
import { ResourceCategory as IResourceCategory } from "@/api/models/resource-category";
import { Video as IVideo } from "@/api/models/video";
import { VideoList as IVideoList } from "@/api/models/video-list";
import RecordListItemTable from "@/components/records/RecordListItemTable.vue";
import { uniqBy } from "lodash";
import api from "@/getinfo-api";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { SortFields, RecordsSort } from "@/plugins/sort-fields";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CSingleSelect,
    CPage,
    CField,
    CustomButton,
    CustomTable,
    RecordListItemTable
  }
})
export default class RecordsList extends Vue {
  searchTitle!: string | undefined;
  videos: Array<IVideo> = [];
  videosCount: number | undefined;
  companyVideos: Array<IVideo> = [];
  companyVideosCount: number | undefined;
  employees!: IEmployeesList2 | undefined;
  ownerId!: string | undefined;
  categoryId!: string | undefined;
  categoryList!: IResourceCategory | undefined;
  showSpinner: boolean = false;
  status!: boolean | undefined;
  limit: number = 30;
  offset: number = 0;
  sorted: SortFields<RecordsSort> = new SortFields(RecordsSort.updatedAt);
  isShowCompanySpinner: boolean = false;
  isShowListenerSpinner: boolean = false;
  locale: string | undefined = "";

  data() {
    return {
      searchTitle: undefined,
      employees: undefined,
      ownerId: undefined,
      categoryId: undefined,
      categoryList: undefined,
      status: undefined,
      videosCount: undefined,
      companyVideosCount: undefined
    };
  }

  get sortStatus() {
    return RecordsSort;
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get userId() {
    return getCurrentUserId();
  }

  get locales() {
    return LearningMaterialLocales();
  }

  acceptSort(sort: RecordsSort) {
    this.sorted.changeSort(sort);
    this.applyFilter();
  }

  showMore() {
    this.offset += this.limit;
    this.getVideos(this.offset);
  }

  showMoreCompanyVideos() {
    this.offset += this.limit;
    this.getCompanyVideos(this.offset);
  }

  getEmployees() {
    let params: EmployeeListParams = {
      roles: ["content_manager"],
      id: this.selectedCompanyId,
      limit: 300
    };

    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.employees = res.data;
    });
  }

  applyFilter() {
    this.offset = 0;
    this.videos = [];
    this.companyVideos = [];
    this.companyVideosCount = undefined;
    this.videosCount = undefined;
    this.showSpinner = true;
    if (this.selectedCompanyId) {
      this.getVideos(this.offset);
      this.getCompanyVideos(this.offset);
    } else {
      this.getVideos(this.offset);
    }
  }

  getCompanyVideos(offset: number = 0) {
    this.isShowCompanySpinner = true;
    if (this.selectedCompanyId) {
      if (this.companyOwner || this.root) {
        let params: VideoListParams = {
          title: this.searchTitle ? this.searchTitle : undefined,
          categoryId: this.categoryId ? this.categoryId : undefined,
          companyId: this.selectedCompanyId,
          ownerId: this.ownerId ? this.ownerId : undefined,
          enabled: this.status !== undefined ? this.status : undefined,
          sort: this.sorted.sort,
          order: this.sorted.order,
          locale: this.locale,
          limit: this.limit,
          offset: offset
        };

        video(params)
          .then((res: { data: IVideoList }) => {
            this.companyVideosCount = res.data.count;
            res.data.videos.forEach(video => {
              this.companyVideos.push(video);
            });
            this.companyVideos = uniqBy(this.companyVideos, "id");
          })
          .finally(() => {
            this.isShowCompanySpinner = false;
          });
      } else {
        let params: VideoListParams = {
          title: this.searchTitle ? this.searchTitle : undefined,
          categoryId: this.categoryId ? this.categoryId : undefined,
          companyId: this.selectedCompanyId,
          ownerId: this.userId,
          limit: this.limit,
          sort: this.sorted.sort,
          order: this.sorted.order,
          locale: this.locale,
          enabled: this.status !== undefined ? this.status : undefined,
          offset: offset
        };

        video(params)
          .then((res: { data: IVideoList }) => {
            this.companyVideosCount = res.data.count;
            res.data.videos.forEach(video => {
              this.companyVideos.push(video);
            });
            this.companyVideos = uniqBy(this.companyVideos, "id");
          })
          .finally(() => {
            this.isShowCompanySpinner = false;
          });
      }
    }
  }

  getVideos(offset: number = 0) {
    this.isShowListenerSpinner = true;
    if (this.root) {
      let params: VideoListParams = {
        title: this.searchTitle ? this.searchTitle : undefined,
        categoryId: this.categoryId ? this.categoryId : undefined,
        limit: this.limit,
        enabled: this.status !== undefined ? this.status : undefined,
        locale: this.locale,
        sort: this.sorted.sort,
        order: this.sorted.order,
        offset: offset
      };

      video(params)
        .then((res: { data: IVideoList }) => {
          this.videosCount = res.data.count;
          res.data.videos.forEach(video => {
            this.videos.push(video);
          });
          this.videos = uniqBy(this.videos, "id");
        })
        .finally(() => {
          this.showSpinner = false;
          this.isShowListenerSpinner = false;
        });
    } else {
      let paramsForListener: VideoListParams = {
        title: this.searchTitle ? this.searchTitle : undefined,
        categoryId: this.categoryId ? this.categoryId : undefined,
        viewerId: this.userId,
        enabled: true,
        limit: this.limit,
        locale: this.locale,
        sort: this.sorted.sort,
        order: this.sorted.order,
        offset: offset
      };

      video(paramsForListener)
        .then((res: { data: IVideoList }) => {
          this.videosCount = res.data.count;
          res.data.videos.forEach(video => {
            this.videos.push(video);
          });
          this.videos = uniqBy(this.videos, "id");
        })
        .finally(() => {
          this.showSpinner = false;
          this.isShowListenerSpinner = false;
        });
    }
  }

  getVideoCategories() {
    if (this.selectedCompanyId) {
      api.VideoApi.categories(undefined, this.selectedCompanyId).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    } else {
      api.VideoApi.categories(this.userId, undefined).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    }
  }

  @Watch("selectedCompanyId")
  updateVideos() {
    this.offset = 0;
    this.videos = [];
    this.companyVideos = [];
    this.companyVideosCount = undefined;
    this.videosCount = undefined;
    this.searchTitle = undefined;
    this.categoryId = undefined;
    this.showSpinner = true;
    this.status = undefined;
    this.ownerId = undefined;
    this.locale = undefined;
    this.status =
      this.root || this.companyOwner || this.contentManager ? undefined : true;
    this.getVideos();
    this.getCompanyVideos();
    this.getVideoCategories();
    this.getEmployees();
  }

  mounted() {
    this.showSpinner = true;
    if (this.selectedCompanyId) {
      this.getVideos();
      this.getCompanyVideos();
      this.getVideoCategories();
      this.getEmployees();
    } else {
      this.getVideos();
    }
  }
}
